<template>
  <div class="tag-select">
    <div v-if="label" class="label" :class="{ [type]: true }">
      {{ label }}
    </div>
    <a-select
      v-if="type === 'select'"
      v-model:value="active"
      :placeholder="$t('qing-xuan-ze')"
      :options="dictList"
      :fieldNames="{ label: 'label', value: 'key' }"
      class="w-[88px]"
      @change="onClick"
    >
      <template #menuItemSelectedIcon>
        <check-outlined />
      </template>
    </a-select>
    <div v-else class="select-list">
      <div
        v-for="item in dictList"
        :key="item.key"
        class="select-item"
        :class="{ [type]: true, active: active === item.key }"
        @click="onClick(item.key)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" name="TagSelect" setup>
import type { DefaultOptionType, SelectValue } from 'ant-design-vue/es/select'
import type { DictItem } from '~/utils/dict'
const { $t } = useNuxtApp()

const props = withDefaults(
  defineProps<{
    modelValue?: SelectValue
    name?: string
    hasAll?: boolean
    allName?: string
    label?: string
    type?: string
    list?: DictItem[]
  }>(),
  {
    hasAll: true,
    // allName: $t('quan-bu'),
    type: 'default',
    list: () => [],
  }
)
const emit = defineEmits(['update:modelValue', 'change'])
const dictList = computed(() => {
  const dicts = props.name ? useDicts(props.name) : []
  const list = props.list.length ? props.list : dicts || []
  const all = { key: 'all', label: props.allName || $t('quan-bu') }
  if (props.hasAll) {
    return [all, ...list]
  }

  return list
})

const active = computed({
  get: () => props.modelValue,
  set: (v) => {
    emit('update:modelValue', v)
    emit('change', v)
  },
})

const onClick = (
  key: SelectValue,
  option?: DefaultOptionType | DefaultOptionType[]
) => {
  active.value = key
}
</script>

<style lang="scss" scoped>
.tag-select {
  @apply flex select-none;
  .label {
    @apply relative text-[14px] text-font-1 leading-[20px] flex justify-center items-center;

    &::after {
      @apply relative inline-block content-[""] w-[1px] h-[12px] mx-[10px] bg-back-6;
    }
    &.default {
      @apply leading-[18px] px-[25px] py-[4px];
      &::after {
        @apply relative top-[2px] h-[14px];
      }
    }
    &.select {
      @apply flex items-center mr-[8px];
      color: rgba(18, 25, 38, 0.45);
      &::after {
        display: none;
      }
    }
  }

  :deep(.ant-select-selector) {
    // background-color: var(--back-3);
    // border: 1px solid transparent;
  }
}
.select-list {
  @apply flex items-center gap-x-[20px];
  .select-item {
    @apply cursor-pointer select-none;

    &.default {
      @apply text-[14px] transition-colors leading-[18px] p-[4px_12px] text-font-70 rounded-[6px];
      &:hover {
        @apply text-primary;
      }
      &.active {
        @apply font-medium bg-back-3 text-primary;
      }
    }

    &.primary {
      @apply cursor-pointer text-[14px] transition-colors select-none leading-[20px];
      color: var(--text-1-60);
      &:hover {
        // color:
        // color: rgba(18, 25, 38, 0.9);
      }
      &.active {
        @apply text-primary font-semibold;
      }
    }
  }
}
</style>
